import { get } from './client.js';

const toQS = (params) => {
  if (!params) return '';
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  );
  return Object.keys(clean).length ? '?' + new URLSearchParams(clean).toString() : '';
};

/* Platform audit log (SA-only) */
export const list = (params) => {
  return get(`/platform/audit${toQS(params)}`);
};

/* Platform activity timeline — business events only, multi-category */
const TIMELINE_CATS = 'Org,Workspace,Plan,Subscription,License,Partner,PlatformUser,Role,Settings,Backup,Security,Member';
export const listTimeline = (params) => {
  const { cat, ...rest } = params ?? {};
  const merged = cat ? { ...rest, cat } : { ...rest, cats: TIMELINE_CATS };
  return get(`/platform/audit${toQS(merged)}`);
};

/* Org-scoped audit log (OA) */
export const listByOrg = (orgId, params) => {
  return get(`/orgs/${orgId}/audit${toQS(params)}`);
};

/* Workspace-scoped audit log (WA+) */
export const listByWorkspace = (wsId, params) => {
  return get(`/workspaces/${wsId}/audit${toQS(params)}`);
};
